module.exports = __webpack_public_path__ + "static/media/vip-access-store-promo-free.609143fc.png";